import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import { AuthContext } from "../context/AuthContext";
import {
  FaWifi, FaPhoneAlt, FaTv, FaFileInvoice, FaExchangeAlt,
  FaSms, FaPrint, FaCheckCircle, FaUniversity, FaClipboard, FaEye, FaEyeSlash, FaChevronRight
} from "react-icons/fa";
import "../styles/dashboard.css";
import ReferralCard from '../components/ReferralCard';
import TransactionPinModal from '../components/TransactionPinModal';
import Account from '../components/Account';

const Dashboard = () => {
  const { currentUser, fetchCurrentUser } = useContext(AuthContext);
  const navigate = useNavigate(); // Initialize navigation function
  const [showBalance, setShowBalance] = useState(true);
  const [showPinModal, setShowPinModal] = useState(false); // ✅ Open modal if no pin
  const fundsNavigate = () => {
    navigate("/add-funds"); // Navigates to the bank account page
  }; 

 


  // Define services with navigation paths
  const services = [
    { icon: <FaWifi />, label: "Buy Data", path: "/buy-data" },
    { icon: <FaPhoneAlt />, label: "Buy Airtime", path: "/buy-airtime" },
    { icon: <FaTv />, label: "Cable Subscription", path: "/buy-cabletv" },
    { icon: <FaFileInvoice />, label: "Bills Payment", path: "/bills-payment" },
    { icon: <FaExchangeAlt />, label: "Airtime to Cash", path: "#" },
    { icon: <FaSms />, label: "Bulk SMS", path: "/bulk-sms" },
    { icon: <FaPrint />, label: "Recharge Card Printing", path: "/recharge-card-printing" },
    { icon: <FaCheckCircle />, label: "Result Checker", path: "/result-checker" },
    { icon: <FaUniversity />, label: "Wallet to Bank Transfer", path: "/withdraw" }
  ];

  return (
     <div style={{ position: "relative" }}>
      {/* ✅ Overlay Modal */}
     
      {/* Account Balance Section */}
      <section className="user-left">
        <h2>Hello <span className="small-size">{currentUser?.username || "User"}, 👋 </span></h2>
      </section>
      <Account/>  


      {/* Info Boxes */}
      <section className="info-boxes">
        {services.map((service, index) => (
          <div
            className="box"
            key={index}
            onClick={() => navigate(service.path)}
            style={{ cursor: "pointer" }}
          >
            {service.icon}
            <span>{service.label}</span>
          </div>
        ))}
      </section>

      {/* Referral Section */}
      <section>
        {currentUser?.referralCode && <ReferralCard referralCode={currentUser.referralCode} />}
      </section>

    </div>
  );
};

export default Dashboard;
